/**
 * Source unique de vérité pour l'URL backend Revyo.
 *
 * - Variable d'env REACT_APP_API_URL replacée au build time par CRA.
 * - Fallback sur la prod URL pour ne pas casser si la variable n'est
 *   pas définie (ex: dev local sans .env.local, build Vercel preview
 *   sans config).
 *
 * Configuration :
 * - Vercel : Settings -> Environment Variables -> ajouter
 *   REACT_APP_API_URL pour Production / Preview / Development.
 * - Local : créer .env.local à la racine de frontend/ avec la ligne :
 *   REACT_APP_API_URL=https://revyo-production.up.railway.app
 *   (ou http://localhost:5000 si tu run le backend en local).
 *
 * NOTE : on ignore explicitement REACT_APP_API_URL si elle pointe
 * sur localhost:3001 (le port du dev server React) — c'est une
 * vieille config bug-prone qui faisait que le frontend s'auto-appelait
 * et retournait des 404 sur toutes les routes API.
 */
const ENV_URL = process.env.REACT_APP_API_URL;
const FALLBACK = 'https://revyo-production.up.railway.app';

// Garde-fou : ignore une URL pointant sur le dev server React lui-même
const isSelfHostingMistake = ENV_URL && /localhost:300[0-9]/.test(ENV_URL);

export const API_BASE = (!ENV_URL || isSelfHostingMistake) ? FALLBACK : ENV_URL;
